// Protéger les itinéraires privés
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Chargement...</div>; // Indicateur de chargement
  }

  return user?.email ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
